import { useContext } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import { ShopThemeContext } from '@/shared/theme';

type Props = {
  height?: number;
  sx?: SxProps<Theme>;
};

const betaBadgeStyles = {
  backgroundColor: '#CA0123',
  color: 'white',
  px: 1,
  py: 0.5,
  borderRadius: '12px',
  fontSize: '0.75rem',
  fontWeight: 'medium',
  alignSelf: 'flex-start',
  mt: 0.5,
} as const;

export const Logo = ({ height = 48, sx }: Props) => {
  const ctx = useContext(ShopThemeContext);
  const actualTheme = ctx?.actualTheme ?? 'light';
  const src = actualTheme === 'dark' ? '/assets/logos/torquetitan-dark.svg' : '/assets/logos/torquetitan-light.svg';

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, ...sx }}>
      <img src={src} alt="TorqueTitan" height={height} />
      <Box component="span" sx={betaBadgeStyles}>
        BETA
      </Box>
    </Box>
  );
};
